import React from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import "./ImageSlider.scss";


const ImageSlider = (props) => {
  return (
    <div className="carousel-condition">
      <AliceCarousel
        responsive={props.ImageSliderData.responsive}
        autoPlayInterval={2000}
        autoPlayDirection="ltr"
        autoPlay={true}
        fadeOutAnimation={true}
        buttonsDisabled={true}
        dotsDisabled={false}
      >
        {props.ImageSliderData.galleryItems.map((image, index) => (
          <img
            className={props.ImageSliderData.ImageClass}
            src={image.src}
            key={index}
            alt={image.alt}
          />
        ))}
      </AliceCarousel>
    </div>
  );
};

export default ImageSlider;
